export const ADMIN = 'ADMIN';
export const CONTRIBUTOR = 'CONTRIBUTOR';
export const MEMBER = 'MEMBER';
